interface AppEnvConfig {
  NODE_ENV: "development" | "production" | "test";
  VITE_API_URL: string | undefined;
  VITE_APP_API_TOKEN: string;
}

class AppConfig {
  private static instance: AppConfig;
  private readonly config: AppEnvConfig;

  private constructor() {
    // Initialize and validate environment variables
    this.config = {
      NODE_ENV: import.meta.env.MODE as "development" | "production" | "test",
      VITE_API_URL: import.meta.env.VITE_API_URL || undefined,
      VITE_APP_API_TOKEN: import.meta.env.VITE_APP_API_TOKEN,
    };
  }

  // Singleton instance
  public static getInstance(): AppConfig {
    if (!AppConfig.instance) {
      AppConfig.instance = new AppConfig();
    }
    return AppConfig.instance;
  }

  // Access environment variables
  private get(key: keyof AppEnvConfig): string | undefined {
    return this.config[key];
  }

  public IsDevelopment(): boolean {
    return this.get("NODE_ENV") === "development";
  }

  public getEnvToken(): string {
    return this.get("VITE_APP_API_TOKEN") || "";
  }

  private apiBaseUrl: string | undefined;

  public ApiBaseUrl(): string {
    const _default = "https://api-prod.tradepeg.com";
    if (!this.apiBaseUrl) {
      if (this.IsDevelopment()) {
        this.apiBaseUrl = this.get("VITE_API_URL") || _default;
      } else {
        this.apiBaseUrl = _default;
      }
    }
    return this.apiBaseUrl;
  }
}

export const appConfig = AppConfig.getInstance();
